var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "gfu-payment-tile",
        { "gfu-payment-tile--selected": _vm.isSelected },
      ],
      attrs: { "data-qa": `payment-method:${_vm.dataQa}` },
    },
    [
      _vm.paymentMethod.label
        ? _c(
            "div",
            { staticClass: "gfu-payment-tile__labels" },
            [
              _c(
                "base-label",
                {
                  attrs: {
                    theme: _vm.paymentMethod.labelTheme,
                    "data-qa": `payment-method-label:${_vm.paymentMethod.label}`,
                  },
                },
                [_vm._v(_vm._s(_vm.paymentMethod.label))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "_cur-p _pa-3",
          on: {
            click: function ($event) {
              return _vm.$emit("select")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "_flex _ai-c" },
            [
              _c("checkbox-field", {
                staticClass: "_mt-0 _mr-2",
                attrs: {
                  value: _vm.isSelected,
                  "show-label": false,
                  name: "paymentMethod",
                  "checked-value": true,
                  type: "radio",
                },
              }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.paymentMethod.name) +
                  "\n\n            "
              ),
              _vm.paymentMethod.imageUrl
                ? _c("base-image", {
                    staticClass: "_ml-a",
                    attrs: {
                      src: _vm.paymentMethod.imageUrl,
                      alt: _vm.paymentMethod.name,
                      width: "34",
                      "data-qa": "payment-method-image",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSelected
            ? [
                !!_vm.paymentMethod.paymentDisclaimer
                  ? _c(
                      "ul",
                      {
                        staticClass: "gfu-list _mt-4",
                        attrs: { "data-qa": "payment-disclaimer" },
                      },
                      _vm._l(
                        _vm.paymentMethod.paymentDisclaimer,
                        function (item) {
                          return _c(
                            "li",
                            { key: item.iconName, staticClass: "_mt-1 _flex" },
                            [
                              _c("base-icon", {
                                staticClass:
                                  "_mr-2 _tc--accent _shrink-0 _py-h",
                                attrs: {
                                  size: "lg",
                                  "is-fixed-width": true,
                                  name: item.iconName,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "_flex _ai-c" }, [
                                _vm._v(_vm._s(item.paragraph)),
                              ]),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isSelected ? _vm._t("default") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }